/* NEX Pulse — original theme scripts */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };

  /* Header: floating pill + hero scroll-grow */
  var header = $('[data-header]');
  var hero = $('[data-hero]');
  var heroFrame = $('[data-hero-frame]');
  var heroImg = $('[data-hero-img]');
  var toTop = $('[data-to-top]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking = false;

  function onScroll() {
    var y = window.scrollY || 0;
    if (header) header.classList.toggle('is-stuck', y > 40);
    if (toTop) toTop.classList.toggle('is-on', y > 700);

    if (hero && heroFrame && !reduce) {
      var rect = hero.getBoundingClientRect();
      var travel = Math.max(1, hero.offsetHeight - window.innerHeight);
      var p = clamp(-rect.top / travel, 0, 1);
      var e = 1 - Math.pow(1 - p, 3);
      var stage = heroFrame.parentElement;
      var narrow = window.innerWidth < 860;
      stage.style.setProperty('--hp', (e * (narrow ? 10 : 36)).toFixed(1) + 'px');
      heroFrame.style.setProperty('--hr', (e * (narrow ? 18 : 34)).toFixed(1) + 'px');
      heroFrame.style.setProperty('--hs', (1.06 - e * 0.06).toFixed(3));
      heroFrame.style.setProperty('--hb', (e * 5).toFixed(1) + 'px');
      heroFrame.style.setProperty('--ho', (1 - p * 1.4 < 0 ? 0 : 1 - p * 1.4).toFixed(2));
      heroFrame.style.setProperty('--hy', (-p * 60).toFixed(1) + 'px');
      // hero image is a sibling of frame vars; mirror onto image element
      if (heroImg) {
        heroImg.style.setProperty('--hs', (1.06 - e * 0.06).toFixed(3));
        heroImg.style.setProperty('--hb', (e * 5).toFixed(1) + 'px');
      }
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  if (toTop) toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* Reveal on scroll */
  var revealEls = $$('.reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Drawer menu */
  var drawer = $('[data-drawer]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    var b = $('[data-menu-open]'); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* Header nav arrows */
  var links = $('[data-nav-links]');
  var np = $('[data-nav-prev]'), nn = $('[data-nav-next]');
  if (links && np && nn) {
    np.addEventListener('click', function () { links.scrollBy({ left: -160, behavior: 'smooth' }); });
    nn.addEventListener('click', function () { links.scrollBy({ left: 160, behavior: 'smooth' }); });
  }

  /* Tabs + carousel */
  $$('[data-tabs]').forEach(function (root) {
    var tabs = $$('[data-tab]', root);
    var panels = $$('[data-panel]', root);
    var ink = $('[data-tab-ink]', root);
    function moveInk(tab) {
      if (!ink || !tab) return;
      ink.style.width = tab.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
    }
    function activePanel() { return panels.filter(function (p) { return !p.hidden; })[0]; }
    function select(tab) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-panel') === tab.getAttribute('data-tab');
        p.hidden = !on;
        if (on) { $$('.reveal', p).forEach(function (el) { el.classList.add('is-in'); }); }
      });
      moveInk(tab);
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { select(t); }); });
    var first = tabs[0];
    if (first) { requestAnimationFrame(function () { moveInk(first); }); window.addEventListener('resize', function () { moveInk(tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0]); }); }

    function step(dir) {
      var p = activePanel(); var car = p && $('[data-car]', p);
      if (!car) return;
      var card = car.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + 20 : 300;
      car.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    var pv = $('[data-car-prev]', root), nx = $('[data-car-next]', root);
    if (pv) pv.addEventListener('click', function () { step(-1); });
    if (nx) nx.addEventListener('click', function () { step(1); });
  });

  /* Collection sort */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* Toast */
  var toast = $('[data-toast]');
  var tt;
  function say(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.classList.add('is-on');
    clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('is-on'); }, 2400);
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }

  /* Product page: variants + ajax add */
  var pdp = $('[data-product]');
  if (pdp) {
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', pdp).textContent); } catch (e) {}
    var form = $('[data-product-form]', pdp);
    var idInput = $('[data-variant-id]', pdp);
    var addBtn = $('[data-add]', pdp);
    var priceEl = $('[data-price]', pdp);
    var qty = $('[data-qty]', pdp);

    function selected() {
      return $$('.opt', pdp).map(function (f) {
        var c = $('input:checked', f); return c ? c.value : null;
      });
    }
    function update() {
      var sel = selected();
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return sel[i] === null || o === sel[i]; }); })[0];
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      priceEl.innerHTML = (v.compare ? '<s>' + v.compare + '</s> ' : '') + v.price;
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      history.replaceState(null, '', u.toString());
    }
    $$('.opt input', pdp).forEach(function (i) { i.addEventListener('change', update); });

    var minus = $('[data-qty-minus]', pdp), plus = $('[data-qty-plus]', pdp);
    if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (+qty.value || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qty.value = (+qty.value || 1) + 1; });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.disabled = true;
      var label = addBtn.textContent; addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +idInput.value, quantity: +qty.value || 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js').then(function (c) { return c.json(); });
      }).then(function (cart) {
        setCount(cart.item_count);
        /* the cart drawer opens with the offer meter; without it, fall back to the small toast */
        if (window.NexCart) document.dispatchEvent(new CustomEvent('nex:added', { detail: cart }));
        else say('Added to your bag');
      }).catch(function () { say('Could not add to bag'); })
        .then(function () { addBtn.disabled = false; addBtn.textContent = label; });
    });
  }
})();